<template>
    <page :busy="busy" :tabs="tabs" :compact-mobile-view="true">
        <template v-if="teamMember">
            <b-container fluid class="team-member-edit d-flex flex-column py-3">
                <h4 class="mx-0 my-0">{{ teamMember.first_name + ' ' + teamMember.last_name }}</h4>
                <div class="team-member-edit-divider my-3" />
                <div v-if="currentTab === detailsTab" class="team-member-edit-tab">
                    <team-member-details-form
                        :initial-values="{
                            id: teamMember.id,
                            first_name: teamMember.first_name,
                            last_name: teamMember.last_name,
                            is_active: teamMember.is_active,
                            login_email: teamMember.email,
                            contact_email: teamMember.client_email,
                            reply_to_email: teamMember.reply_to_email,
                            ctape_display_guest_phone: teamMember.permissions_override.ctape_display_guest_phone,
                            ctape_display_guest_email: teamMember.permissions_override.ctape_display_guest_email,
                            reports_display_cleaning_fees: teamMember.permissions_override.reports_display_cleaning_fees,
                            work_order_display_all_assignees: teamMember.permissions_override.work_order_display_all_assignees,
                            ctape_display_within_admin_app: teamMember.permissions_override.ctape_display_within_admin_app,
                        }"
                    ></team-member-details-form>
                </div>
                <div v-else-if="currentTab === accessTab" class="team-member-edit-tab">
                    <team-member-edit-access :team-member="teamMember"></team-member-edit-access>
                </div>
                <div v-else-if="currentTab === communicationTab" class="team-member-edit-tab">
                    <team-member-edit-communication :team-member="teamMember"></team-member-edit-communication>
                </div>
                <div v-else-if="currentTab === propertiesTab" class="team-member-edit-tab">
                    <team-member-edit-properties :team-member="teamMember"></team-member-edit-properties>
                </div>
                <div v-else-if="currentTab === logTab" class="team-member-edit-tab">
                    <team-member-edit-log :team-member="teamMember"></team-member-edit-log>
                </div>
            </b-container>
        </template>
    </page>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Page from '../../generic/page/page.vue';
    import TeamMemberDetailsForm from '../common/team-member-details-form.vue';
    import TeamMemberEditAccess from './team-member-edit-access/team-member-edit-access.vue';
    import TeamMemberEditCommunication from './team-member-edit-communication/team-member-edit-communication.vue';
    import TeamMemberEditProperties from './team-member-edit-properties/team-member-edit-properties.vue';
    import TeamMemberEditLog from './team-member-edit-log.vue';

    export default {
        name: 'TeamMemberEdit',
        components: {
            Page,
            TeamMemberDetailsForm,
            TeamMemberEditAccess,
            TeamMemberEditCommunication,
            TeamMemberEditProperties,
            TeamMemberEditLog,
        },
        computed: {
            ...mapGetters('teamMember', ['teamMember']),
            teamMemberID() {
                return parseInt(this.$route.params.id);
            },
            currentTab() {
                const tab = this.tabs.find(tab => tab.active);
                return tab ? tab.tabId : 1
            },
            tabs() {
                const tabList = [
                    {
                        title: `Team Members`,
                        route: `/app/team-member/list/`,
                        active: false,
                        tabId: 0,
                    },
                    {
                        title: `Details`,
                        route: `/app/team-member/${this.teamMemberID}/edit/`,
                        active: this.$route.path === `/app/team-member/${this.teamMemberID}/edit/`,
                        tabId: 1,
                    },
                    {
                        title: `Access`,
                        route: `/app/team-member/${this.teamMemberID}/edit/access/`,
                        active: this.$route.path === `/app/team-member/${this.teamMemberID}/edit/access/`,
                        tabId: 2,
                    },
                    {
                        title: `Communication`,
                        route: `/app/team-member/${this.teamMemberID}/edit/communication/`,
                        active: this.$route.path === `/app/team-member/${this.teamMemberID}/edit/communication/`,
                        tabId: 3,
                    },
                    {
                        title: `Properties`,
                        route: `/app/team-member/${this.teamMemberID}/edit/properties/`,
                        active: this.$route.path === `/app/team-member/${this.teamMemberID}/edit/properties/`,
                        tabId: 4,
                    },
                    {
                        title: `Log`,
                        route: `/app/team-member/${this.teamMemberID}/edit/log/`,
                        active: this.$route.path === `/app/team-member/${this.teamMemberID}/edit/log/`,
                        tabId: 5,
                    },
                ]
                return this.teamMember && this.teamMember.group_id === 6 ? tabList : tabList.filter(tab => tab.tabId != 4)
            }
        },
        data() {
            return {
                busy: false,
                detailsTab: 1,
                accessTab: 2,
                communicationTab: 3,
                propertiesTab: 4,
                logTab: 5,
            }
        },
        mounted() {
            this.$store.commit('teamMember/resetTeamMember');

            (async () => {
                this.busy = true;
                try {
                    await this.fetchTeamMember();
                } finally {
                    this.busy = false;
                }
            })();
        },
        beforeUnmount() {
            this.$store.commit('teamMember/resetTeamMember');
        },
        methods: {
            async fetchTeamMember() {
                try {
                    await this.$store.dispatch('teamMember/fetchTeamMember', { id: this.teamMemberID });
                } catch (err) {
                    this.errorToast({text: 'Could not load team member data.'})
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.team-member-edit {
    height: 100%;
    &-tab {
        flex: 1;
        width: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        .lx-grid {
            height: 100% !important;
        }
    }
    &-divider {
        width: 100%;
        height: 1px;
        background-color: rgba(0, 0, 0, 0.1);;
    }
}
</style>